import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import Screen from 'bento-ordering/base/components/Screen';
import { getCustomLayoutNavbar } from 'bento-ordering/base/constants/customLayouts';
import selectLayout from 'bento-ordering/base/selectors/selectLayout';

function BaseLayout({ hideNav, isModal, ...rest }) {
  const layout = useSelector(selectLayout);
  const Navbar = getCustomLayoutNavbar(layout);

  return (
    <Box pt={isModal ? {} : { xs: 7, sm: 8 }}>
      {!hideNav && <Navbar />}
      <Screen isModal={isModal} {...rest} />
    </Box>
  );
}

BaseLayout.propTypes = {
  hideNav: PropTypes.bool,
  isModal: PropTypes.bool
};

export default BaseLayout;
